import { useTranslation } from 'react-i18next'

import { useTimeZone } from '../../../hooks'
import Text from '../../Text'

import { getChatroomStartedLabel } from './ChatroomStartedLine.utils'

import * as styles from './ChatroomStartedLine.module.css'

function ChatroomStartedLine({ createdAt }) {
  const { t } = useTranslation()

  const timeZone = useTimeZone()

  const label = getChatroomStartedLabel({ createdAt, t, timeZone })

  return label ? (
    <div className={styles.chatroomStartedLine}>
      <Text isSecondary>{label}</Text>
    </div>
  ) : null
}

export default ChatroomStartedLine
